import styled from '@emotion/styled';

/** Vertical stack for the modal body — copy, optional warning banner, and the action row. */
export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 480px;
`;

/** Right-aligned Cancel / Confirm button row. */
export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
